import { MonitorPlan } from "../types/monitor";

import ApiService from "./ApiService";

type GetPropertyAreaMonitorPlanRespose = {
  data: MonitorPlan;
};

const PropertyAreaService = {
  GetPropertyAreaMonitorPlan: async (
    propertyAreaId: string
  ): Promise<GetPropertyAreaMonitorPlanRespose> => {
    return ApiService.Get(`property-areas/${propertyAreaId}/monitor-plan`);
  },
};

export default PropertyAreaService;
